module.exports = __webpack_public_path__ + "img/logo.6a89e72e.png";